import { escapeHtml } from './html';

/**
 * Consent-gated iframes (YouTube, Google Maps …).
 * Markup: <iframe data-kockica-category="marketing" data-src="https://www.youtube-nocookie.com/embed/…"></iframe>
 * Without consent the iframe has no src and a placeholder with an "allow" button is shown instead.
 */

export interface IframeTexts {
  notice: (categoryTitle: string) => string;
  button: string;
  categoryTitle: (category: string) => string;
}

const placeholders = new WeakMap<HTMLIFrameElement, HTMLElement>();

export function applyIframes(
  accepted: readonly string[],
  texts: IframeTexts,
  allow: (category: string) => void,
  root: ParentNode = document,
): void {
  root.querySelectorAll<HTMLIFrameElement>('iframe[data-kockica-category]').forEach((frame) => {
    const category = frame.dataset.kockicaCategory ?? '';
    const src = frame.dataset.src ?? '';
    const placeholder = placeholders.get(frame);

    if (accepted.includes(category)) {
      if (src && frame.getAttribute('src') !== src) frame.setAttribute('src', src);
      frame.hidden = false;
      placeholder?.remove();
      placeholders.delete(frame);
      return;
    }

    // Not allowed (or withdrawn): make sure nothing loads.
    if (frame.hasAttribute('src')) frame.removeAttribute('src');
    frame.hidden = true;
    if (placeholder) return;

    const box = document.createElement('div');
    box.className = 'kockica-iframe-placeholder';
    box.setAttribute('data-kockica-placeholder', category);
    const title = texts.categoryTitle(category);
    box.innerHTML = `<p>${escapeHtml(texts.notice(title))}</p><button type="button">${escapeHtml(texts.button)}</button>`;
    box.querySelector('button')?.addEventListener('click', () => allow(category));
    frame.insertAdjacentElement('afterend', box);
    placeholders.set(frame, box);
  });
}
